import type { ProgramPricingData } from "@/lib/ecommerce/commercetools/client-only/getProgramPricingData";

export type ProgramPricingAmounts = {
  price: number;
  originalPrice?: number;
};

const isPositivePrice = (value?: number | null): value is number =>
  value != null && value > 0;

export const getProgramPricingAmounts = (
  pricingData?: Partial<ProgramPricingData> | null,
): ProgramPricingAmounts | null => {
  const originalPrice = isPositivePrice(pricingData?.originalPrice)
    ? pricingData.originalPrice
    : undefined;
  const discountedPrice = isPositivePrice(pricingData?.discountedPrice)
    ? pricingData.discountedPrice
    : undefined;
  const price = discountedPrice ?? originalPrice;

  if (!price) {
    return null;
  }

  if (originalPrice && discountedPrice && originalPrice !== discountedPrice) {
    return { price: discountedPrice, originalPrice };
  }

  return { price };
};
